import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.127.895v15.21h4.57V.895h-4.57ZM3.303.895v15.21h4.57V.895h-4.57Z",
  stroke: "#F59600",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.167 3.267a.595.595 0 0 0-.585-.605.595.595 0 0 0-.585.605c0 .334.262.605.585.605a.595.595 0 0 0 .585-.605ZM6.167 5.445a.595.595 0 0 0-.585-.605.595.595 0 0 0-.585.605c0 .335.262.606.585.606a.595.595 0 0 0 .585-.606ZM12.99 3.267a.595.595 0 0 0-.584-.606.595.595 0 0 0-.585.606c0 .334.262.605.585.605a.595.595 0 0 0 .585-.605ZM12.99 5.445a.595.595 0 0 0-.584-.605.595.595 0 0 0-.585.605c0 .335.262.606.585.606a.595.595 0 0 0 .585-.606Z",
  fill: "#F59600"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };